import { Box, Typography } from "@bca/ui-library";

import { Vehicle } from "../Interfaces/vehicle.type";
import { formatMoney } from "../formatMoney";
import { vatStatusMapper } from "../Mappers/vehicleDetailsMappers";
import PurchasePriceSVG from "../Icons/PurchasePriceSVG";

interface PriceProps {
  vehicle: Vehicle;
}

const Price: React.FunctionComponent<PriceProps> = ({ vehicle }) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="flex-start"
      width="50%"
      mr={5}
    >
      <PurchasePriceSVG />
      <Box display="flex" flexDirection="column" marginLeft={2}>
        <Typography
          variant="h6"
          color="footer-blue"
          htmlTag="p"
          marginTop={0}
          marginBottom={0}
          marginRight={1}
        >
          {formatMoney(vehicle.bidAmount)}
        </Typography>
        <Typography
          variant="label"
          color="footer-blue"
          htmlTag="p"
          marginTop={1}
          marginBottom={0}
          fontWeight="normal"
        >
          {vatStatusMapper[vehicle.vatType]}
        </Typography>
      </Box>
    </Box>
  );
};

export default Price;
